export enum FontWeight {
  Normal = 400,
  Medium = 500,
  Bold = 700,
}
